import {
  Box,
  Button,
  FormControl,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { CustomGreenButton } from "../Button/CustomButton";
import Iconify from "../Dashboard/Iconify";
import { continueButtonStyle } from "../MangeSuccessfulBusiness/dialogStyles/DialogStyles";
import { useSelector } from "react-redux";

const getStoryState = (state) => state.successStoryReducer;

export const customHelperText = {
  fontSize: "12px",
  fontStyle: "italic",
  textTransform: "initial",
};
const FormTwo = ({
  activeStep,
  handleSubmit,
  handleBack,
  steps,
  handleStoryForm,
  formValues,
  formStates,
}) => {
  const { storyIsCreating } = useSelector(getStoryState);

  return (
    <React.Fragment>
      <Box p="20px 10px">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl fullWidth variant="outlined">
              <label
                style={{
                  marginBottom: "10px",
                  fontFamily: Typography.secondaryFont,
                }}
                htmlFor="story"
              >
                <Typography sx={{ fontSize: "14px" }}>Success Story</Typography>
              </label>
              <TextField
                size="small"
                name="story"
                id="story"
                multiline
                rows={6}
                variant="outlined"
                value={formValues.storyFormValues.story}
                error={formStates.storyError}
                helperText={formStates.storyErrorMsg}
                inputProps={{
                  spellCheck: true,
                  lang: "English",
                }}
                onChange={handleStoryForm}
              />
            </FormControl>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
        <Button
          color="inherit"
          disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ mr: 1, textTransform: "capitalize" }}
        >
          Back
        </Button>
        <Box sx={{ flex: "1 1 auto" }} />

        <CustomGreenButton onClick={handleSubmit} loading={storyIsCreating}>
          {activeStep === steps.length - 1 ? (
            <span
              style={{
                padding: "2px 18px",
              }}
            >
              Save & Submit
            </span>
          ) : (
            <span style={continueButtonStyle}>
              Continue <Iconify icon="material-symbols:arrow-forward-rounded" />
            </span>
          )}
        </CustomGreenButton>
      </Box>
    </React.Fragment>
  );
};

export default FormTwo;
